import React from 'react';
import { motion } from 'framer-motion';
const benefits = [{
  icon: '🌿',
  text: 'Llegar a tu periodo más preparada, sin esperar a estar destruida para recién hacer algo.'
}, {
  icon: '💥',
  text: 'Reducir molestias comunes como dolor, hinchazón, cólicos, cansancio y malestar corporal.'
}, {
  icon: '🧠',
  text: 'Calmar la ansiedad y el sobrepensamiento, especialmente esos días donde todo se siente más intenso.'
}, {
  icon: '💞',
  text: 'Evitar que el PMS afecte tanto tu relación, tus discusiones y tu forma de reaccionar.'
}, {
  icon: '📚',
  text: 'Sostener mejor tu productividad, sin que el premenstrual te tire a la cama o te arruine el trabajo/la facultad.'
}];
export function BenefitsGrid() {
  return <section className="py-20 bg-cream px-4 sm:px-6 lg:px-8" data-id="element-15">
      <div className="max-w-6xl mx-auto" data-id="element-16">
        {/* Happy woman with mate — golden hour, pink robe */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7
      }} className="relative w-full max-w-3xl mx-auto mb-16 rounded-2xl overflow-hidden shadow-2xl" data-id="element-17">
          <img src="https://cdn.magicpatterns.com/uploads/jcFPZPwZtgYwXVy5spCQAq/ChatGPT_Image_21_may_2026,_07_56_51_p.m..png" alt="Mujer feliz tomando mate y usando la Guía Ciclo en Calma 5x5 en su celular" className="w-full h-[320px] md:h-[450px] object-cover object-center" data-id="element-18" />
          <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent" data-id="element-19"></div>
          <div className="absolute bottom-6 left-6 right-6 text-white" data-id="element-20">
            <p className="font-serif italic text-lg md:text-2xl drop-shadow-lg" data-id="element-21">
              "Por fin un mes en calma."
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-22">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-dark mb-4" data-id="element-23">
            Lo que vas a lograr con el Kit 5x5
          </h2>

          <div className="w-24 h-1 bg-gold mx-auto mt-6" data-id="element-24"></div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-25">
          {benefits.map((benefit, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className={`bg-white p-8 rounded-2xl shadow-sm border border-gray-100 flex items-start space-x-4 ${index === benefits.length - 1 ? 'md:col-span-2 md:max-w-2xl md:mx-auto' : ''}`} data-id="element-26">
              <div className="flex-shrink-0 w-12 h-12 bg-cream rounded-full flex items-center justify-center text-2xl" data-id="element-27">
                {benefit.icon}
              </div>
              <div data-id="element-28">
                <p className="text-gray-800 font-medium text-base md:text-lg leading-relaxed" data-id="element-29">
                  {benefit.text}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}